'use client';
import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { createClient } from '@/lib/supabase/client';
import { forgeGoalsService } from '@/lib/services/forgeGoalsService';

export default function ProfileHeader() {
  const [profileName, setProfileName] = useState('Hunter');
  const [dayNumber, setDayNumber] = useState(1);
  const [todayStr, setTodayStr] = useState('');

  useEffect(() => {
    const today = new Date();
    setTodayStr(today?.toLocaleDateString('en-ZA', { day: '2-digit', month: 'long', year: 'numeric' }));

    const supabase = createClient();
    supabase?.auth?.getUser()?.then(async ({ data: { user } }) => {
      if (!user) return;
      const name = user?.user_metadata?.full_name || user?.email?.split('@')?.[0] || 'Hunter';
      setProfileName(name);

      const profile = await forgeGoalsService?.getUserProfile(user?.id);
      if (profile?.mission_start_date) {
        const start = new Date(profile.mission_start_date);
        const diff = Math.floor((today?.getTime() - start?.getTime()) / (1000 * 60 * 60 * 24));
        setDayNumber(Math.max(1, diff + 1));
      }
    });
  }, []);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <div className="text-forge-label mb-1">Active Profile</div>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 border-2 border-primary/40 flex items-center justify-center">
            <span className="text-lg font-black text-primary">{profileName?.charAt(0)?.toUpperCase()}</span>
          </div>
          <div>
            <h1 className="text-2xl font-black tracking-wider text-foreground">{profileName?.toUpperCase()}</h1>
            <p className="text-xs text-muted-foreground">Day {dayNumber} of mission · {todayStr}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="text-right mr-3">
          <div className="text-forge-label">Today&apos;s Principle</div>
          <div className="text-sm font-medium text-muted-foreground italic">
            &ldquo;Weight is feedback.&rdquo;
          </div>
        </div>
        <Link
          href="/food-logging"
          className="btn-forge-primary px-4 py-2 rounded-md text-sm"
        >
          + LOG FOOD
        </Link>
        <Link
          href="/the-anvil"
          className="btn-forge-ghost px-4 py-2 rounded-md text-sm"
        >
          CHECK-IN
        </Link>
      </div>
    </div>
  );
}